module.exports = __webpack_public_path__ + "img/map.049b74f8.svg";